module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAALBAMAAABBvoqbAAAAJ1BMVEUAAACBh42Bh42Bh42Bh42Bh42Bh42Bh42Bh42Bh42Bh42Bh42Bh43h1oPFAAAADHRSTlMA1w8Wxr4a3cwxHr9+IiprAAAALUlEQVQI12OYasDAwBAjDCQ0DiYwMDD5iAGZKscXMDAwn9kAZoHEwLIQdWAdABzaClhJBECZAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_next.png
// module id = D68w
// module chunks = 9